/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatalistAnagrafica, Paginator, Sorting, SortingDirectionEnum } from '@models';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';
import { ViewerService } from '@shared/services/viewer.service';

@Component({
    selector: 'app-toolkit-rilievo-tab-opere-associate',
    templateUrl: './tab-opere-associate.component.html',
})
export class ToolkitGestioneRilievoTabOpereAssociateComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() formGroup: FormGroup;
    @Input() datalist: DatalistAnagrafica;
    @Input() items: any;
    public tableSort: Sorting[] = [];
    public paginator: Paginator = new Paginator();


    constructor(private router: Router, private utilsService: UtilsService, 
        private operaService: OperaService, private viewerService: ViewerService,
        private route: ActivatedRoute,
        ) {}
    
    ngOnInit() {
        if (this.canEdit === false) {
            this.formGroup.disable();
        }
        this.tableSort = [
            { field: 'idOpera', direction: SortingDirectionEnum.EMPTY },
            { field: 'denProv', direction: SortingDirectionEnum.EMPTY },
            { field: 'denComune', direction: SortingDirectionEnum.EMPTY },
        ];

        this.submitForm()
    }

    public submitForm() {
        // this.utilsService.setFormDataSession(FormDataSessionEnum.OPERA_RICERCA, {idRilievo: this.formGroup.get('idRilievo')});
        this.operaService.search({idRilievo: this.formGroup.get('idRilievo')?.value}, this.paginator.getQueryPaginator(this.tableSort)).subscribe(response => {
            this.items = response;
            this.paginator.setTotalPage(response.totalElements);
        });
    }

    public onPageChange($event: number) {
        this.paginator.page = $event;
        this.submitForm();
    }

    public goToOpera(idOpera: number) {
        this.router.navigate(['private/gestione-opera/dettaglio', idOpera]);
    }

    // public goToViewer(idOpera: number, codIstat: string, idTipologiaOpera: number) {
    //     this.viewerService.getUrlViewerOpera(idOpera, codIstat, idTipologiaOpera).subscribe((response: any) =>
    //         window.open(response.urlViewer, 'blank')
    //     )
    // }

    public sortTable(ordinamento: any, index: number) {
        this.tableSort[index].direction = ordinamento.direction ? ordinamento.direction : ordinamento;
        this.submitForm();
    }

}
